// React
import React from "react";

const Overlay = ({ activeIndex }) => {
  return activeIndex !== null && <div className="overlay"></div>;
};

export default Overlay;
